import React from "react"
import { Toggle } from "material-ui"
import autobind from "class-autobind"
import { EOTType, IOvertimeRule } from "../../../models"
import strings from "../../../localization/strings"
import OvertimeRuleChip from "./OvertimeRuleChip"

interface IProps {
    otType: EOTType
    error: string
    overtimeRules: IOvertimeRule[]
    handleChange(overtimeRules: IOvertimeRule[]): void
}
interface IState {
    customOvertimeRule: boolean
}

export default class CustomOvertimeRule extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            customOvertimeRule: props.overtimeRules.length > 0,
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <Toggle
                    label={strings.Custom_Overtime}
                    toggled={this.state.customOvertimeRule}
                    onToggle={(e, value) => {
                        this.setState({ customOvertimeRule: value })
                        !value && this.props.handleChange([])
                    }}
                    style={{ maxWidth: 175 }}
                    labelStyle={{ fontSize: 15 }}
                />
                {this.state.customOvertimeRule &&
                    <OvertimeRuleChip
                        otType={this.props.otType}
                        overtimeRules={this.props.overtimeRules}
                        error={this.props.error}
                        handleChange={this.props.handleChange}
                    />
                }
            </div>
        )
    }
}